<template>
    <div>
        <loader v-if="!isDataAvailable" style="min-height: 100px;" />
        <form @submit.prevent class="form-horizontal" data-vv-scope="workflowSubmit">
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('workflowSubmit.workflowStatusId') }" style="margin-top: 50px; solid 1px;" v-if="hasAtLeastOneNextStatus">
                <label class="col-md-2 control-label">Action</label>
                <div class="col-md-4">
                    <select name="workflowStatusId" class="form-control" v-model="workflowStatusId" v-validate="'required'">
                        <option disabled value="">Select action</option>
                        <option v-for="item in workflowStatusDtoNextList" v-bind:key="item.workflowStatusId" v-bind:value="item.workflowStatusId">
                            {{ item.submitDescription}}
                        </option>
                    </select>
                    <div><span v-show="errors.has('workflowSubmit.workflowStatusId')" class="has-error">Next Status is required</span></div>
                </div>
            </div>
            <div class="form-group" v-if="workflowStatusId === 3800 && !isUserShpo">
                <label class="col-md-2 control-label">&nbsp;</label>
                <div class="col-md-10" style="color:red;" >
                    WARNING: By submitting to QA/QC Review, you will not receive SHPO review.
                </div>
            </div>
            <div class="form-group" v-if="assignableUserList.length > 0" v-bind:class="{ 'has-error': errors.has('workflowSubmit.assignedUserId') }">
                <label class="col-md-2 control-label">Assign User</label>
                <div class="col-md-6">
                    <select name="assignedUserId" class="form-control" v-model="assignedUserId" v-validate="'required'">
                        <option disabled value="">Select user to assign</option>
                        <option v-for="item in assignableUserList" v-bind:key="item.userId" v-bind:value="item.userId">
                            {{ item.name }}
                        </option>
                    </select>
                    <div><span v-show="errors.has('workflowSubmit.assignedUserId')" class="has-error">Assign User is required</span></div>
                </div>
            </div>
            <!-- Undertaking block -->
            <div class="form-group" v-show="isUndertakingAssignable">
                <span class="col-md-2"></span>
                <div class="col-md-6">
                    <undertakingModal v-if="isUndertakingAssignable" ref="undertakingModal"></undertakingModal>
                </div>
            </div>
            <!-- end Undertaking block -->
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('workflowSubmit.notes') }" v-if="hasAtLeastOneNextStatus">
                <label class="col-md-2 control-label">Note</label>
                <div class="col-md-6">
                    <textarea name="notes" class="form-control" v-model="notes" placeholder="Notes" v-validate="noteValidationRules"></textarea>
                    <div><span v-show="errors.has('workflowSubmit.notes')" class="has-error">Notes are required</span></div>
                </div>
            </div>
            <div class="form-group" v-show="canCloseUndertaking">
                <label class="col-md-2 control-label checkbox-label">Close undertaking?</label>
                <div class="col-md-4 checkbox-inline">
                    <input type="checkbox" v-model="closeUndertaking" id="undertakingcheckbox" />
                </div>
            </div>
            <div class="form-group" v-show="canCloseE106">
                <label class="col-md-2 control-label checkbox-label">Close E106 Compliance?</label>
                <div class="col-md-4 checkbox-inline">
                    <input type="checkbox" v-model="closeE106" id="e106checkbox" />
                </div>
            </div>
            <div class="form-group" v-show="canReturnSites">
                <label class="col-md-2 control-label checkbox-label">Return All Sites?</label>
                <div class="col-md-4 checkbox-inline">
                    <input type="checkbox" v-model="returnSites" id="sitescheckbox" />
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-2 control-label">&nbsp;</label>
                <div class="col-md-4">
                    <validationResultDisplay :validationResult="validationResult"></validationResultDisplay>
                </div>
            </div>
            <div class="form-group" v-if="hasAtLeastOneNextStatus">
                <div class="text-center" v-show="checkFieldWorkRequestErrors">
                    <span class="has-error" style="font-size:1em">Form must be completed prior to submit</span>
                </div>
                <label class="col-md-2 control-label">&nbsp;</label>
                <div class="col-md-2">
                    <button class="btn btn-primary btn-block" v-on:click="workflowSubmit">Submit</button>
                </div>
            </div>
        </form>
        <div v-show="isDebug" style="margin-top: 20px;">
            <div>
            <h3 class="text-danger">****** Debug ****** - {{componentName}}</h3>
            </div>
            <div>
            <h4>Validation errors: </h4>
            <pre>{{ errors }}</pre>
            noteValidationRules<br/><pre>{{ noteValidationRules }}</pre>
            </div>
            <div>
            workflowStatusId: {{ workflowStatusId }}<br/>
            selectedWorkflowStatusDto: <pre>{{selectedWorkflowStatusDto}}</pre><br/>
            workflowStatusDtoNextList<br/><pre>{{ workflowStatusDtoNextList }}</pre>
            </div>
        </div>
    </div>
</template>

<style>
</style>

<script>
import loggingService from '@/services/util/loggingService'
import componentService from '@/services/util/componentService'
import workflowService from '@/services/workflowService'
import investigationService from '@/services/investigationService'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import { mapState } from 'vuex'

import loader from '@/components/Loader.vue'
import validationResultDisplay from '@/components/ValidationResultDisplay.vue'
import undertakingModal from '@/components/Undertaking/UndertakingModal.vue'

import _ from 'lodash/lodash.min.js'

export default {
    components: {
        loader,
        validationResultDisplay,
        undertakingModal
    },
    name: 'workflowSubmit',
    data: function () {
        return {
            isDebug: false,
            closeUndertaking: false,
            closeE106: false,
            investigationRelatedWorkflows: null,
            selectedWorkflowStatusDto: null,
            assignableUserList: [],
            validationResult: {},
            workflowStatusId: '',
            currentWorkflowStatusId: null,
            notes: '',
            assignedUserId: '',
            onSubmitSuccessEventName: 'workflowSubmitOnSubmitSuccess',
            onBeforeSubmitEventName: 'workflowBeforeSubmit',
            serverErrorList: [],
            invWfStatusEnum: workflowService.InvestigationWorkflowStatusEnum,
            returnSites: false,
            shpoRcUserRoles: [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser,
                roleService.RoleEnum.ShpoRcAdministrator
            ],
            currentWorkflowStatusInstanceDto: null,
            culturalResourceList: []
        }
    },
    props: {
        workflowInstanceId: {
            type: Number
        },
        workflowStatusDtoNextList: {
            type: Array
        },
        fieldworkRequestErrors: {
            default: null
        },
        investigation: {
            default: null
        }
    },
    computed: {
        // compute current user info
        ...mapState({
            shpoUserDto: state => (state.auth.shpoUserDto || {})
        }),
        isUserShpo: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList)
        },
        canCloseUndertaking: function () {
            return (userService.hasRoleCheck(this.shpoUserDto.roleList, this.shpoRcUserRoles)) &&
                this.invHasUndertaking && this.workflowStatusId && this.workflowStatusId === 3800
        },
        canCloseE106: function () {
            return (userService.hasRoleCheck(this.shpoUserDto.roleList, this.shpoRcUserRoles)) &&
                this.isE106 && this.workflowStatusId && this.workflowStatusId === 3800
        },
        investigationId: function () {
            if (this.investigation) {
                return this.investigation.investigationId
            }
            if (this.$parent.$parent.investigation) {
                return this.$parent.$parent.investigation.investigationId
            }
            if (this.$parent.culturalResourceRecording) {
                return this.$parent.culturalResourceRecording.investigationId
            }
            return null
        },
        isE106: function () {
            if (this.investigationRelatedWorkflows) {
                return this.investigationRelatedWorkflows.e106ComplianceId
            } else {
                return false
            }
        },
        invHasUndertaking: function () {
            if (this.investigationRelatedWorkflows) {
                return this.investigationRelatedWorkflows.undertakingId
            } else {
                return false
            }
        },
        componentName: function () {
            return componentService.getComponentNameDebug(this)
        },
        isDataAvailable: function () {
            return this.workflowStatusDtoNextList != null
        },
        noteValidationRules () {
            var expression = {
                rules: {
                    required: true
                }
            }

            loggingService.log(this.isDebug, this.componentName, 'computed.noteValidationRules')
            if (this.workflowStatusId) {
                var handle = this
                if (handle.selectedWorkflowStatusDto && handle.selectedWorkflowStatusDto.isNoteRequired) {
                    //loggingService.log(this.isDebug, this.componentName + ' - computed.noteValidationRules', 'required')
                    expression.rules.required = true
                } else {
                    ///loggingService.log(this.isDebug, this.componentName + ' - computed.noteValidationRules', 'not required')
                    expression.rules.required = false
                }
            } else {
                //loggingService.log(this.isDebug, this.componentName + ' - computed.noteValidationRules', 'not required, workflowStatusId not selected')
                expression.rules.required = false
            }

            //loggingService.logRaw(this.isDebug, expression)
            return expression
        },
        hasAtLeastOneNextStatus () {
            return this.workflowStatusDtoNextList != null && this.workflowStatusDtoNextList.length > 0
        },
        checkFieldWorkRequestErrors () {
            if (this.fieldworkRequestErrors && this.workflowStatusId === workflowService.FwrWorkflowStatusEnum.PendingApproval) {
                return this.fieldworkRequestErrors.any()
            } else {
                return false
            }
        },
        isUndertakingAssignable () {
            if (!this.hasAtLeastOneNextStatus) return false
            var assign = false
            var validWfStatuses = [
                this.invWfStatusEnum.PendingUndertaking,
                this.invWfStatusEnum.E106UndertakingAssigned
            ]

            //check if investigation is agencyNoReview or acting as consultant
            if (this.investigation && this.investigation.investigationAgencyRole) {
                if (this.investigation.investigationAgencyRole === 1) { //Agency No Review
                    validWfStatuses.push(this.invWfStatusEnum.PendingSHPOApproval)
                    validWfStatuses.push(this.invWfStatusEnum.PendingQaqc)
                }
                if (this.investigation.investigationAgencyRole === 2) { //Acting as Consultant
                    validWfStatuses.push(this.invWfStatusEnum.PendingAgencyAssignment)
                }
            }

            if (this.workflowStatusDtoNextList) {
                this.workflowStatusDtoNextList.forEach(e => {
                    if (validWfStatuses.includes(e.workflowStatusId)) {
                        assign = true
                    }
                })
            }
            return assign
        },
        isAssignedUndertakingSelected () {
            if (this.selectedWorkflowStatusDto &&
            (this.selectedWorkflowStatusDto.workflowStatusId === this.invWfStatusEnum.AssignedUndertaking ||
            this.selectedWorkflowStatusDto.workflowStatusId === this.invWfStatusEnum.E106UndertakingAssigned)) {
                return true
            } else {
                return false
            }
        },
        canReturnSites () {
            var currentWfsId = (this.currentWorkflowStatusInstanceDto || {}).workflowStatusId
            var shpoReturnWfs = [
                this.invWfStatusEnum.PendingAgencyApproval,
                this.invWfStatusEnum.PendingDataEntry
            ]
            return this.investigationId && this.workflowStatusId &&
            (
                (currentWfsId === this.invWfStatusEnum.PendingAgencyApproval && this.workflowStatusId === this.invWfStatusEnum.PendingDataEntry) ||
                (currentWfsId === this.invWfStatusEnum.PendingSHPOApproval && shpoReturnWfs.includes(this.workflowStatusId)) ||
                (currentWfsId === this.invWfStatusEnum.PendingUndertaking && shpoReturnWfs.includes(this.workflowStatusId))
            )
        }
    },
    watch: {
        workflowStatusId: function (val) {
            loggingService.log(this.isDebug, this.componentName + ' - watch.workflowStatusId: ', val + ', workflowStatusId: ' + this.workflowStatusId)

            if (this.workflowStatusId) {
                var handle = this
                this.selectedWorkflowStatusDto = _.find(this.workflowStatusDtoNextList, function (item) { return item.workflowStatusId === parseInt(handle.workflowStatusId) })

                this.assignableUserList = this.selectedWorkflowStatusDto.assignableUserList
            } else {
                this.assignableUserList = []
            }

            if (this.workflowInstanceId) {
                workflowService.listWorkflowStatusInstanceDto(this.$http, this.workflowInstanceId).then(response => {
                    if (response.data) {
                        response.data.sort((a, b) => a.createdDate > b.createdDate ? -1 : 1)
                        this.currentWorkflowStatusInstanceDto = response.data[0]
                    }
                })
            }
        },
        investigationId: function () {
            if (this.investigationId) {
                investigationService.getRelatedItemWorkflows(this.$http, this.investigationId).then(response => {
                    this.investigationRelatedWorkflows = response.data
                })
            }
        }
    },
    methods: {
        workflowSubmit: function () {
            loggingService.log(this.isDebug, this.componentName, 'workflowSubmit')

            this.$validator.validateAll('workflowSubmit').then(result => {
                loggingService.log(this.isDebug, this.componentName + ' - workflowSubmit', 'workflowInstanceId: ' + this.workflowInstanceId + ', workflowStatusId: ' + this.workflowStatusId + ', assignedUserId: ' + this.assignedUserId + ', notes: ' + this.notes)
                if (result) {
                    loggingService.log(this.isDebug, this.componentName + ' - workflowSubmit', 'form validated')
                    this.$emit(this.onBeforeSubmitEventName)
                    loggingService.log(this.isDebug, this.componentName + ' - workflowSubmit', 'onBeforeSubmit event has returned')
                    if (window.confirm('Are you sure you want to submit?')) {
                        // check for fieldwork request form errors, only proceed to submit if no errors
                        if (!this.checkFieldWorkRequestErrors) {
                            this.validationResult = { messages: [] }
                            var handle = this
                            //handle investigations going to QA/QC
                            if (this.investigationRelatedWorkflows && this.workflowStatusId === 3800) {
                                var e106Workflow = this.investigationRelatedWorkflows.e106ComplianceWorkflowInstanceId
                                var undertakingWorkflow = this.investigationRelatedWorkflows.undertakingWorkflowInstanceId
                                var newWorkflow = this.investigationRelatedWorkflows.e106ComplianceNextStatusId
                                //if user selects "close e106" on investigation, close e106 compliance
                                if (this.closeE106 && e106Workflow) {
                                    loggingService.log(this.isDebug, 'workflowSubmit', 'closing e106')
                                    workflowService.submit(this.$http, e106Workflow, newWorkflow, this.notes, this.assignedUserId).then(function (response) {
                                        if (response.data.isValid) {
                                            handle.submitPrimaryWorkflow()
                                            //if user selects "close undertaking" on investigation, close associated undertaking
                                            if (handle.closeUndertaking && undertakingWorkflow) {
                                                loggingService.log(handle.isDebug, 'workflowSubmit', 'closing undertaking')
                                                workflowService.submit(handle.$http, undertakingWorkflow, 8900, handle.notes, handle.assignedUserId)
                                            }
                                        } else {
                                            handle.validationResult.messages.push('E106 Compliance cannot be closed yet.')
                                        }
                                    })
                                } else { //if user did not select close e106
                                    this.submitPrimaryWorkflow()
                                    //if user selects "close undertaking" on investigation, close associated undertaking
                                    if (this.closeUndertaking && undertakingWorkflow) {
                                        loggingService.log(this.isDebug, 'workflowSubmit', 'closing undertaking')
                                        workflowService.submit(this.$http, undertakingWorkflow, 8900, this.notes, this.assignedUserId)
                                    }
                                }
                            } else if (this.returnSites) {
                                workflowService.returnAllSites(this.$http, this.investigation.investigationId, this.workflowStatusId).then(() => {
                                    this.submitPrimaryWorkflow()
                                })
                            } else { //handle all other workflows
                                this.submitPrimaryWorkflow()
                            }
                        }
                    }
                } else {
                    loggingService.log(this.isDebug, 'Workflow', 'submitWorkflow - invalid form')
                }
            })
        },
        submitPrimaryWorkflow: function () {
            var handle = this
            //submit primary workflow request
            workflowService.submit(this.$http, this.workflowInstanceId, this.workflowStatusId, this.notes, this.assignedUserId).then(function (response) {
                loggingService.log(handle.isDebug, handle.componentName + ' - workflowSubmit', 'submit complete')

                // handler for if the current object is removed as a result of workflow submit
                if (response.data.currentItemRemoved) {
                    // if isolate is removed, go back to investigation
                    if (handle.$parent.$parent.$parent.$parent.investigation) {
                        var investigationId = handle.$parent.$parent.$parent.$parent.investigation.investigationId
                        handle.$router.push('/Investigation/' + investigationId)
                        return
                    }
                }
                if (response.data.isValid) {
                    handle.$validator.clean()
                    handle.selectedWorkflowStatusDto = null
                    handle.$emit(handle.onSubmitSuccessEventName, response.data)
                    //if CRR, redirect to investigation
                    if (handle.workflowStatusId >= 5000 && handle.workflowStatusId < 6000 && handle.investigationId) {
                        handle.$router.push('/Investigation/' + handle.investigationId + '#siteSummary')
                    }
                } else {
                    handle.validationResult = response.data
                }
            })
        },
        clearForm: function () {
            loggingService.log(this.isDebug, this.componentName, 'clearForm')
            this.workflowStatusId = ''
            this.notes = ''
        }
    },
    created () {
        loggingService.log(this.isDebug, this.componentName, 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, this.componentName, 'mounted')
    },
    destroyed () {
        loggingService.log(this.isDebug, this.componentName, 'destroyed')
    }
}
</script>

<style>
#e106checkbox, #undertakingcheckbox, #sitescheckbox {
    height: 20px; 
    width: 20px; 
    margin-left: -15px; 
    margin-top: 1px;
}
</style>



// WEBPACK FOOTER //
// workflowSubmit.vue?541f0f1e